import React from 'react';

const questions: {question: string, answer: string | React.ReactElement}[] = [
	{
		question: 'Notice!',
		answer: <>
			<ul>
				<li>
					Romhack Races is on a temporary haitus while we work on new races and events to host. This includes a tech improvement to the site and other programs used for hosting races.
				</li>
				<li>
					Some of the FAQ items below may be outdated or not have working links while we work on the new site. It will be back up and running when we launch v2!
				</li>
			</ul>
		</>
	},
	{
		question: 'How do I race?',
		answer: <>
			<ul>
				<li>
					You can sign up here: <a href='https://romhackraces.com/signups'>Race Signups</a>. You have to sign up again every race.
				</li>
				<li>
					We will show the current top four racers on our Twitch channel, https://twitch.tv/RomhackRaces. You may opt out of being restreamed when signing up.
				</li>
				<li>
					If you are signed up to be restreamed, we require the following:<br />
					<ol>
						<li>
							Use our custom layout: https://bit.ly/Romhack_Race_Layout. Your game must be contained in the left window, as we will only show that section on the restream.
						</li>
						<li>
							Your mic and any custom audio must be disabled so that the only sounds are from the game being played. Anything visual that is not the game (alerts, your webcam, and any overlays) must not show inside the main window of the race layout, but are allowed to be in the right-side column as that part of your stream will not be shown.
						</li>
						<li>
							Your stream quality must be capped at 720p or you must have transcoding so that we can watch your stream at a lower quality. NES and SNES games do not need many pixels to understand what is going on, and the lower bandwidth requirement for our restreamer and scouts means the positions are more accessible to more people.
						</li>
						<li>
							Rules for the race must be followed and can be found in our Discord server. A basic and not exhaustive list is no savestates, slowdown, cheat codes, opening the game patch in a development tool, turbo buttons, or cheating in general. 
						</li>
					</ol>
				</li>
				<li>
					Five minutes before the race starts, the patch file for the race will be provided. Apply the patch, wait for our bot to do a countdown and say "Go!", and then race! For Super Mario World, your time ends when the fade out happens to account for potential post-goal trolls.
				</li>
			</ul>
		</>
	},
	{
		question: 'How do I sign up as a level creator?',
		answer: <p>Signups are temporarily closed while we work on the new site. Check back soon!</p>
	},
	{
		question: 'How do I sign up to help out with streaming, hosting, testing, etc?',
		answer: <>
			<p>You can fill out applications for each position as below</p>
			<ul>
				<li>Scout Application</li>
				<li>Restreamer Application</li>
				<li>Playtester Application</li>
				<li>Host Application</li>
			</ul>
		</>
	},
	{
		question: 'How does being a level creator work?',
		answer: 'When you want to sign up as a level creator, you can enter your name at https://bit.ly/Romhack_Races_Racedates and you will need to join our Discord server. One week before your race date, we will ask you to provide the patch for your level and it will be tested by the playtesters. They will offer advise to make sure the level is Race Ready. That generally means the level works as intended, is a fun experience for racers, does not have any soft locks, and the difficulty is roughly consistent. Suggestions may be offered so the race can be iterated on, and once it is Race Ready the testers will rate it. Then it gets raced!'
	},
	{
		question: 'How do I play the weekly levels?',
		answer: 'Romhack Races does not provide game files, so we will give a patch that can be used to create the race level. Floating IPS, or Flips, can be used to modify your game file with the patch. Please see the directions for Flips for more info about patching games.'
	}
];

export default questions;